import { deleteTag as _deleteTag } from '@griply/services';
import { deleteDoc, doc, getFirestore } from 'firebase/firestore';
import { ID } from 'shared/types/id';

export const deleteTag = async (id: ID): Promise<void> =>
  _deleteTag({
    tagId: id,
    db: getFirestore(),
    doc,
    deleteDoc,
  });
